import { Component, OnInit,  ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { RpcClientService } from 'src/app/service/rpc-client.service';

@Component({
  selector: 'app-display-diagnostic',
  templateUrl: './display-diagnostic.component.html',
  styleUrls: ['./display-diagnostic.component.scss']
})
export class DisplayDiagnosticComponent implements OnInit {
  diagvin: any
  diagdisabledGroup: boolean = true;
  diagdisabledcomponent: boolean = true;
  diagdisabledSection: boolean = true;
  diagchangeSectionList: boolean = false;
  diagflagsection: boolean = false;
  diagsecheck: boolean = false;
  diagcocheck: boolean = false;
  diaggroupSearch: any = [];
  diagcomponentSearch: any = [];
  diagsectionArray: any = [];
  diagsectionArrayvalues: any = [];
  diagsecIndex: any;
  diagsectionNameRecieved = '';
  diagmanualData: any;
  diaggroupName: any = '';
  diaggroupnamereq: any = '';
  diagsectionName = '';
  diagsectionnamereq: any = '';
  diagcomponentName: any = '';
  diagcompnamereq: any = '';
  diagerrormsg: any = '';
  diagtokenObj: any;
  diagcomparenames: any;
  diagsectionNameHolder: any;
  diaguserId: any;
  diagcompid: any;
  diagindex: any;
  diagcomponentId: any;
  diagerrorflag: boolean = false;
  isShowLoader: boolean = true;
  selectedRoles: string[] = [];
  isRvcGenUser: boolean = false;
  dealerCode: string = '';
  rvcCode: string = '';
  isLoading: boolean = false;
  diagWccCode: any = '';
  diagActualComponentId: any = '';
  diagSelectedComponentDetails: any = null;
  isComponentDetailsLoaded: boolean = false;
  isFetchingComponentDetails: boolean = false;
  showCopiedMessage: boolean = false;
  userName:string = '';

  constructor(private service: ApifirstService, private router: Router, private translate: TranslateService,private rpcClient: RpcClientService, private elementRef: ElementRef ) { }

  ngOnInit(): void {
    localStorage.setItem("component",'');
    this.rpcClient.checkFDRSConnectionStatus();

    this.service.tokenObj.subscribe((data: any) => {
      this.diagtokenObj = data;
      this.diagvin = this.diagtokenObj.vin;
      this.dealerCode = this.diagtokenObj.dealerCode
      this.userName = this.diagtokenObj.username
    })

    this.service.userId.subscribe((data: string) => {
      if(data != "") {
        this.diaguserId = data;
        this.vinNumberChange(this.diagvin);
      }
    })

    this.service.userRoles$.subscribe((roles: string[]) => {
      this.selectedRoles = roles;
      if(this.selectedRoles.includes("RVC_GEN_USER")) {
        this.isRvcGenUser = true;
      }
    });
  }

  generateRvc() {
    if (!this.diagActualComponentId || this.diagActualComponentId === '') {
      this.rvcCode = 'Error generating RVC';
      return;
    }

    this.isLoading = true;
    this.rvcCode = '';
    this.showCopiedMessage = false;

    const request = {
      vin: this.diagvin,
      countryCode: this.diagtokenObj.countryThree,
      languageCode: this.diagtokenObj.language,
      userType: this.diagtokenObj.userType,
      dealerCode: this.dealerCode || this.diagtokenObj.dealerCode,
      componentId: this.diagActualComponentId,
      warrantyDealerCode: this.dealerCode || this.diagtokenObj.dealerCode,
      diagnosticMethod: "MANUAL_TECHNICIAN",
      technicianNotes: [],
      wcc: (this.diagWccCode && String(this.diagWccCode).trim() !== '') ? String(this.diagWccCode).trim() : null
    };

    this.service.generateRvc(request,this.userName).subscribe({
      next: (result: string) => {
        console.log("=== RVC GENERATED SUCCESSFULLY ===");
        this.rvcCode = result
        this.isLoading = false;
      },
      error: (error: any) => {
        console.error('=== RVC GENERATION ERROR ===');
        console.error(error);
        this.rvcCode = 'Error generating RVC';
        this.isLoading = false;
      }
    });
  }

  copyRvc() {
    if (!this.rvcCode || this.rvcCode === 'Error generating RVC') {
      return;
    }
    this.fallbackCopyToClipboard(this.rvcCode);
  }

  private fallbackCopyToClipboard(text: string) {
    let textarea = document.createElement('textarea');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    textarea.value = text;
    this.elementRef.nativeElement.appendChild(textarea);

    textarea.select();
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this.showFeedbackMessage();
      } else {
      }
    } catch (err) {
    } finally {
      this.elementRef.nativeElement.removeChild(textarea);
    }
  }
  private showFeedbackMessage() {
    this.showCopiedMessage = true;
    setTimeout(() => {
      this.showCopiedMessage = false;
    }, 2000); // Message disappears after 2 seconds
  }

  vinNumberChange(diagvin: any) {
    const pattern = new RegExp('^(?:(?![IOQioq])[A-Za-z0-9])+$');
    /** validate the input vin number */
    if ((this.diagvin == null || this.diagvin == undefined || this.diagvin == '' || this.diagvin.length === 0)) {
      this.diagerrormsg = this.translate.instant('Please supply a VIN Number');
      this.diagerrorflag = true;
    } else if (this.diagvin.length < 17 && this.diagvin.length !== 0) {
      this.diagerrormsg = this.translate.instant('VINs should be 17 characters long');
      this.diagerrorflag = true;
    } else if (!pattern.test(this.diagvin)) {
      this.diagerrormsg = this.translate.instant('VIN validation');
      this.diagerrorflag = true;
    } else {
      this.diagerrormsg = '';
      this.diagerrorflag = false;
    }

// Reset all component-related data
    this.resetComponentData();

    const identifyObj = {
      "vin": diagvin,
      "filtered": "true",
      "diagnostic": "true",
      "userId": this.diaguserId,
      "userType": this.diagtokenObj.userType,
      "languageCode": this.diagtokenObj.language,
      "countryCode": this.diagtokenObj.countryThree,
      "sessionId": -1
    }
    if (!this.diagerrorflag) {
      this.service.getIdentifydetails(identifyObj).subscribe((data: any) => {
        this.isShowLoader = false;
        this.diaggroupSearch = [];
        this.diagmanualData = data;
        this.diaggroupSearch = this.diagmanualData.groupList? this.diagmanualData.groupList : [];
        this.diagdisabledGroup = false;
        if (!(this.diaggroupSearch.includes(this.translate.instant('Other not on list')))) {
          this.diaggroupSearch.push(this.translate.instant('Other not on list'));
        }
        this.diaggroupName = "default";
        this.diagsectionName = "default";
        this.diagcomponentName = "default";
        this.diagsectionNameHolder = "default";
      })
    }
    else {
      this.diaggroupSearch = [];
    }
  }
  resetComponentData() {
    this.diaggroupSearch = [];
    this.diagsectionArray = [];
    this.diagcomponentSearch = [];
    this.diagdisabledGroup = true;
    this.diagdisabledSection = true;
    this.diagdisabledcomponent = true;
    this.diaggroupName = "default";
    this.diagsectionName = "default";
    this.diagcomponentName = "default";
    this.diagsectionNameHolder = "default";
    this.diagsecheck = false;
    this.diagcocheck = false;
    this.diagActualComponentId = '';
    this.diagWccCode = '';
    this.diagcomponentId = '';
    this.isComponentDetailsLoaded = false;
    this.rvcCode = '';
  }

  /* to select group*/
  diagonSelectgroup(diagsetGroupname: any, value: number) {
    this.diaggroupName = diagsetGroupname;
    this.diagdisabledSection = true;
    this.diagsecheck = false;
    this.diaggroupName = diagsetGroupname;
    this.diagdisabledSection = true;
    this.diagsecheck = false;
    this.diagActualComponentId = '';
    this.diagWccCode = '';
    this.diagSelectedComponentDetails = null;
    this.isComponentDetailsLoaded = false;
    this.rvcCode = '';
    if (value == 1) {
      this.diagdisabledcomponent = true;
      this.diagcomponentName = "default";
      this.diagsectionName = "default";
    }
    if (this.diaggroupName == "default") {
      this.diagdisabledSection = true;
      this.diagdisabledcomponent = true;
      this.diagcomponentName = "default";
      this.diagsectionName = "default";
    } else {
      if (this.diaggroupName == (this.translate.instant('Other not on list'))) {
        this.diagsecheck = true;
        this.diagcocheck = true;
        if (value == 1) {
          this.diagdisabledcomponent = true;
          this.diagcomponentName = "default";
        }
        this.diagflagsection = true;
        this.diagsectionName = "diagflagsection";
        this.diagsectionNameRecieved = "diagflagsection";
        this.diagcomponentName = "diagflagsection";
        this.diagcompid = "0";
        this.diagdisabledcomponent = false;
        this.diagsectionNameHolder = "default";
      } else {
        this.diagsecheck = false;
        this.diagcocheck = false;
        this.diagflagsection = false;
        if (this.diaggroupName == (this.translate.instant('Other not on list'))) {
          this.diaggroupnamereq = "0";
        } else {
          this.diaggroupnamereq = this.diaggroupName;
        }
        if (this.diagsectionName == "diagflagsection") {
          this.diagsectionnamereq = "0";
        } else {
          this.diagsectionnamereq = this.diagsectionName;
        }
        let req = {
          "userType": this.diagtokenObj.userType,
          "language": this.diagtokenObj.language,
          "countryCode": this.diagtokenObj.countryThree,
          "vin": this.diagvin,
          "userId": this.diaguserId,
          "sessionid": -1,
          "group": this.diaggroupnamereq,
          "section": "",
          "component": "",
          "componentSearch": "",
          "pageState": "filterSection",
          "failureComments": "",
          "labourOnly": "",
          "finisCode": "",
          "filtered": "true",
          "diagnostic": "true"
        }
        this.service.getSectionList(req).subscribe((data: { sectionQualifierList: any; sectionList: { [s: string]: unknown; } | ArrayLike<unknown>; }) => {
          this.diagdisabledSection = false;
          if (this.diagchangeSectionList) {
            this.diagsectionNameHolder = this.diagsectionName;
            if (this.diagsectionNameHolder == "diagflagsection") {
              this.diagsectionNameHolder = "default";
              this.diagdisabledcomponent = true;
              this.diagcomponentName = "default";
            }
            this.diagsectionArray = [];
            let filteredArray = [];
            this.diagsectionArray = data.sectionQualifierList;
            this.diagsectionArray.push(this.translate.instant('Other not on list'));
            this.diagcomparenames = this.diagsectionName.substring(0, 6);
            for (let i of this.diagsectionArray) {
              if (i.substring(0, 6) == this.diagcomparenames) {
                filteredArray.push(i);
              }
            }
            let str = filteredArray[1];
            if (filteredArray.length == 1) {
              str = filteredArray[0];
            }
            this.diagsectionName = str;
            if (this.diagsectionName == "diagflagsection") {
              this.diagsectionName = "default";
            }
            if (this.diagsectionNameHolder == "default" || this.diagsectionName == "default") {
              this.diagsectionName = "default";
            }
          } else if (!this.diagchangeSectionList) {
            this.diagsectionArray = [];
            this.diagsectionArray = Object.keys(data.sectionList);
            this.diagsectionArrayvalues = Object.values(data.sectionList);
            this.diagsectionArray.push(this.translate.instant('Other not on list'));
            if (this.diagsectionName == "diagflagsection") {
              this.diagsectionName = "default";
            } else {
              this.diagsectionName = this.diagsectionNameHolder;
              this.diagsectionNameHolder = "default";
            }
            if (this.diagsectionNameHolder == "diagflagsection") {
              this.diagsectionNameHolder = "default";
              this.diagdisabledcomponent = true;
              this.diagcomponentName = "default";
            }
            if (this.diagsectionName == "diagflagsection") {
              this.diagdisabledcomponent = true;
            }
          }
        },(err: any) => {
          /* if we get the response as error */
          this.diagcomponentName = "default";
          this.diagsectionName = "default";
          this.diagdisabledcomponent = true;
          this.diagdisabledSection = true;
        })
      }
    }
  }
  /* to select section*/
  diagonSelectSection(setSectionname: any) {
    this.diagdisabledcomponent = true;
// Reset component data when section changes
    this.diagActualComponentId = '';
    this.diagWccCode = '';
    this.isComponentDetailsLoaded = false;
    this.rvcCode = '';

    if (this.diagsectionName != "diagflagsection") {
      this.diagcomponentName = "default";
    }
    if (setSectionname == "default") {
      this.diagdisabledcomponent = true;
      this.diagcomponentName = "default";
    } else {
      if (this.diaggroupName == (this.translate.instant('Other not on list'))) {
        this.diagsecheck = true;
        this.diagcocheck = true;
        this.diagcompid = "0";
        if (this.diagsectionName == "default") {
          this.diagdisabledcomponent = true;
          this.diagcomponentName = "default";
        } else {
          this.diagsectionName = "diagflagsection";
          this.diagsectionNameRecieved = "diagflagsection";
          this.diagdisabledcomponent = false;
          this.diagcomponentName = "diagflagsection";
        }
        this.diagflagsection = true;
      }
      else {
        this.diagsecheck = false;
        this.diagcocheck = false;
        this.diagflagsection = false;
        this.diagsecIndex = this.diagsectionArray.findIndex((data: any) => {
          return data == setSectionname;
        })
        if (this.diagchangeSectionList) {
          if (setSectionname == (this.translate.instant('Other not on list'))) {
            this.diagsectionNameRecieved = "diagflagsection";
            this.diagcomponentName = "diagflagsection";
            this.diagflagsection = true;
          } else {
            this.diagsectionNameRecieved = setSectionname;
          }
        }
        else {
          if (setSectionname == (this.translate.instant('Other not on list'))) {
            this.diagsectionNameRecieved = "diagflagsection";
            this.diagcomponentName = "diagflagsection";
            this.diagflagsection = true;
          } else {
            this.diagsectionNameRecieved = this.diagsectionArrayvalues[this.diagsecIndex];
          }
        }
        if (this.diaggroupName == (this.translate.instant('Other not on list'))) {
          this.diaggroupnamereq = "0";
        } else {
          this.diaggroupnamereq = this.diaggroupName;
        }
        if (this.diagsectionNameRecieved == "diagflagsection") {
          this.diagsectionnamereq = "0";
        } else {
          this.diagsectionnamereq = this.diagsectionNameRecieved;
        }
        let req = {
          "userType": this.diagtokenObj.userType,
          "language": this.diagtokenObj.language,
          "countryCode": this.diagtokenObj.countryThree,
          "vin": this.diagvin,
          "userId": this.diaguserId,
          "sessionid": -1,
          "group": this.diaggroupnamereq,
          "section": this.diagsectionnamereq,
          "component": "",
          "componentSearch": "",
          "pageState": "filterComponent",
          "failureComments": "",
          "labourOnly": "",
          "finisCode": "",
          "filtered": "true",
          "diagnostic": "true"
        }
        this.service.getComponentList(req).subscribe((data: { componentList: { [s: string]: unknown; } | ArrayLike<unknown>; }) => {
          this.diagdisabledcomponent = false;
          let toFetchSectionData = [];
          toFetchSectionData = Object.values(data.componentList);
          this.diagcomponentSearch = toFetchSectionData;
          this.diagcompid = Object.keys(data.componentList);
          this.diagcomponentSearch.push(this.translate.instant('Other not on list'));
          this.diagcompid.push('0');
        },(err: any) => {
          /* if we get the response as error */
          this.diagcomponentName = "default";
          this.diagdisabledcomponent = true;
        })
        if (this.diagsectionNameRecieved == "diagflagsection" || this.diagsectionName == "diagflagsection") {
          this.diagcomponentName = "diagflagsection";
          this.diagcompid = "0";
        }
      }
    }
  }
  /*to select component*/
  diagonSelectComponent(setCompname: any) {
    this.rvcCode = '';
    if (setCompname === 'default') {
      this.diagcomponentName = 'default';
      this.diagcomponentId = '';
      this.diagActualComponentId = '';
      this.diagWccCode = '';
      this.isFetchingComponentDetails = false;
      this.isComponentDetailsLoaded = false;
      return;
    }
    if (this.diagcomponentName == "diagflagsection") {
    }
    else {
      this.diagcomponentName = setCompname;
      this.diagindex = this.diagcomponentSearch.findIndex((data: any) => {
        return data == setCompname;
      })
      this.diagcomponentId = this.diagcompid[this.diagindex];
      this.isComponentDetailsLoaded = false;
      this.isFetchingComponentDetails = true;
      this.diagActualComponentId = '';
      this.diagWccCode = '';
      if (this.isRvcGenUser && this.diagcomponentId !== '0') {
        this.fetchComponentDetails();
      } else {
        this.isFetchingComponentDetails = false;
        this.isComponentDetailsLoaded = false;
        this.diagActualComponentId = '';
        this.diagWccCode = '';
      }
    }
  }

  isOtherNotOnListSelected() {
    const other = this.translate.instant('Other not on list');
    return (
      this.diaggroupName === other ||
      this.diagsectionName === other ||
      this.diagcomponentName === other
    );
  }

  fetchComponentDetails() {

    this.isFetchingComponentDetails = true;
    this.isComponentDetailsLoaded = false;
    this.diagActualComponentId = '';
    this.diagWccCode = '';
    this.diagSelectedComponentDetails = null;

    if (this.diaggroupName == (this.translate.instant('Other not on list'))) {
      this.diaggroupnamereq = "0";
    } else {
      this.diaggroupnamereq = this.diaggroupName;
    }

    if (this.diagsectionNameRecieved == "diagflagsection") {
      this.diagsectionnamereq = "0";
    } else {
      this.diagsectionnamereq = this.diagsectionNameRecieved;
    }

    if (this.diagcomponentId == undefined) {
      this.diagcompnamereq = "0";
    } else {
      this.diagcompnamereq = this.diagcomponentId;
    }

    const req = {
      "userType": this.diagtokenObj.userType,
      "language": this.diagtokenObj.language,
      "countryCode": this.diagtokenObj.countryThree,
      "vin": this.diagvin,
      "userId": this.diaguserId,
      "sessionid": -1,
      "group": this.diaggroupnamereq,
      "section": this.diagsectionnamereq,
      "component": this.diagcompnamereq,
      "componentSearch": "",
      "pageState": "componentSelected",
      "failureComments": "",
      "labourOnly": "",
      "finisCode": "",
      "filtered": "true",
      "diagnostic": "true"
    };

    this.service.getComponentSelected(req).subscribe({
      next: (response: { id: any; wcc: any; }) => {

        if (response) {
          this.diagSelectedComponentDetails = response;
          this.diagActualComponentId = response.id;
          const receivedWcc = response.wcc;
          if (receivedWcc === null || receivedWcc === undefined || String(receivedWcc).trim() === '' || String(receivedWcc).trim().toLowerCase() === 'null') {
            this.diagWccCode = null;
          } else {
            this.diagWccCode = String(receivedWcc).trim();
          }

          this.isComponentDetailsLoaded = true;

         } else {
          if (this.diagcomponentId && this.diagcomponentId !== '0') {
            this.diagActualComponentId = this.diagcomponentId;
          } else {
            this.diagActualComponentId = '';
          }
          this.diagWccCode = '';
        }

        this.isComponentDetailsLoaded = true;
        this.isFetchingComponentDetails = false;
      },
      error: (error: any) => {
        this.diagActualComponentId = '';
        this.diagWccCode = '';
        this.diagSelectedComponentDetails = null;

        this.isComponentDetailsLoaded = true;
        this.isFetchingComponentDetails = false;

        this.diagerrormsg = this.translate.instant('Failed to load component details');
        this.diagerrorflag = true;

      }
    });
  } }
